import type { TFunction } from 'i18next'
import type { BomImportReviewDialogLabels } from '@/shared/components/bom/BomImportReviewDialog'

export function buildV2BomImportReviewLabels(t: TFunction<'common'>): BomImportReviewDialogLabels {
  const base = 'v2.pages.products.detail.parts.import.mapping'
  return {
    title: t(`${base}.title`),
    description: t(`${base}.description`),
    requiredFieldsHelper: t(`${base}.requiredFieldsHelper`),
    skuLabel: t(`${base}.skuLabel`),
    supplierLabel: t(`${base}.supplierLabel`),
    nameLabel: t(`${base}.nameLabel`),
    placeholder: t(`${base}.placeholder`),
    nameNone: t(`${base}.nameNone`),
    columnFallback: (index) => t(`${base}.columnFallback`, { index }),
    rowColumn: t(`${base}.rowColumn`),
    statusColumn: t(`${base}.statusColumn`),
    statusPending: t(`${base}.statusPending`),
    statusWillImport: t(`${base}.statusWillImport`),
    statusSkuRequired: t(`${base}.statusSkuRequired`),
    statusSupplierRequired: t(`${base}.statusSupplierRequired`),
    statusSkuAndSupplierRequired: t(`${base}.statusSkuAndSupplierRequired`),
    summary: (invalidCount, totalCount) =>
      t(`${base}.invalidSummary`, { invalidCount, totalCount }),
    columnsMustDiffer: t(`${base}.columnsMustDiffer`),
    skuMappingRequired: t(`${base}.skuRequired`),
    supplierMappingRequired: t(`${base}.supplierRequired`),
    cancel: t('actions.cancel'),
    import: t(`${base}.submit`),
    importPartial: (count) => t(`${base}.submitPartial`, { count }),
  }
}

export function buildPortalBomImportReviewLabels(
  t: TFunction<'common'>
): BomImportReviewDialogLabels {
  const base = 'catalogSupplierPortal.productParts.import.mapping'
  return {
    title: t(`${base}.title`),
    description: t(`${base}.description`),
    requiredFieldsHelper: t(`${base}.requiredFieldsHelper`),
    skuLabel: t(`${base}.skuLabel`),
    supplierLabel: t(`${base}.supplierLabel`),
    nameLabel: t(`${base}.nameLabel`),
    placeholder: t(`${base}.placeholder`),
    nameNone: t(`${base}.nameNone`),
    columnFallback: (index) => t(`${base}.columnFallback`, { index }),
    rowColumn: t(`${base}.rowColumn`),
    statusColumn: t(`${base}.statusColumn`),
    statusPending: t(`${base}.statusPending`),
    statusWillImport: t(`${base}.statusWillImport`),
    statusSkuRequired: t(`${base}.statusSkuRequired`),
    statusSupplierRequired: t(`${base}.statusSupplierRequired`),
    statusSkuAndSupplierRequired: t(`${base}.statusSkuAndSupplierRequired`),
    summary: (invalidCount, totalCount) =>
      t(`${base}.invalidSummary`, { invalidCount, totalCount }),
    columnsMustDiffer: t(`${base}.columnsMustDiffer`),
    skuMappingRequired: t(`${base}.skuRequired`),
    supplierMappingRequired: t(`${base}.supplierRequired`),
    cancel: t('actions.cancel'),
    import: t(`${base}.submit`),
    importPartial: (count) => t(`${base}.submitPartial`, { count }),
  }
}
